import { httpDomainService } from "../../http-common";
import { IRateType } from "../../model/domainServices/IRateType";
import { IPaginationResult } from "../../model/search/IPaginationResult";
import { ISearch } from "../../model/search/ISearch";

//Search
const getSearch = async (objISearch: ISearch) => {
    const params = JSON.stringify({
      search: objISearch.search,
      sortBy: objISearch.sortBy,
      sortOrder: objISearch.sortOrder,
      filterBy: {
        negotiated:objISearch.filterBy?.negotiated,
        columnName: "",
        columnValue: ""
      },
      paginationInfo: {
        perPage: objISearch.pagination.perPage,
        page: objISearch.pagination.page,
      },
    });
  
    const data = await httpDomainService.post<IPaginationResult<IRateType>>(
      "/rate_types/get",
      params,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("domainService_token")}`,
        },
      }
    );
    
    return data;
  };

  const getById = async (id: string) => {
    const data = await httpDomainService.post<IRateType>(
      `/rate_types/get/${id}`,
      "",
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("domainService_token")}`,
        },
      }
    );
  
    return data;
  };

  const getByOracleId = async (oracleId: number) => {
    const data = await httpDomainService.post<IRateType>(
      `/rate_types/get/${oracleId}`,
      "",
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("domainService_token")}`,
        },
      }
    );
  
    return data;
  };
  
  export const RateTypeService = {
    getSearch,
    getById,
    getByOracleId
  };

  export const getRateType = (rateTypeStateResult:IPaginationResult<IRateType>, rateTypeId:string) => {
    if(rateTypeStateResult != null)
    {
      const result = rateTypeStateResult.data.find(value => value.rateTypeId === rateTypeId);
      return result;
    }
    else{
      return undefined;
    }
  }

  export const bindRateTypeDropdown = (rateTypePaginationResult:IPaginationResult<IRateType>): {label:string,value:string}[] => {
    const options = [];
    
    if(rateTypePaginationResult != null)
    {
      for (let i = 0; i < rateTypePaginationResult.data.length; i++) {
        let obj = {label: rateTypePaginationResult.data[i].type, value: rateTypePaginationResult.data[i].rateTypeId};
        options.push(obj);
      }
    }

    return options;
  }